import { useEffect, useState } from 'react'

const readFromLocalStorage = (key) => {
  if (typeof window === 'undefined') {
    return null
  }

  return localStorage.getItem(key)
}

export default function getToken() {
  return readFromLocalStorage('access_token')
}

export function getUserDetail() {
  const userDetail = readFromLocalStorage('userDetail')

  if (!userDetail) {
    return null
  }

  try {
    return JSON.parse(userDetail)
  } catch {
    return null
  }
}

export function useStoredAccessToken() {
  const [token, setToken] = useState(null)

  useEffect(() => {
    setToken(getToken())
  }, [])

  return token
}

export function useStoredUserDetail() {
  const [userDetail, setUserDetail] = useState(null)

  useEffect(() => {
    setUserDetail(getUserDetail())
  }, [])

  return userDetail
}
